export default __webpack_public_path__ + "static/media/insert_drive_file.ec9955e6.svg";